import { createUseCase } from '~core/usecase/createUseCase';
// import { getPersonalizedBrandRanking } from '~graphql/queries';
import {
  changedOffset,
  changedPage,
  recievedBrands,
  selectBrandListState,
} from '~redux/search/brand';
import {
  BrandReadModel,
  // GetPersonalizedBrandRankingQuery,
  // GetPersonalizedBrandRankingQueryVariables,
} from '~types/api';
import { executeQuery } from '~utils/graphql';
import { warn } from '~utils/log';
import { getFlag } from '~view/contexts/FlagsContext';

export const getPersonalizedBrands = createUseCase(
  'search/brand/getPersonalizedBrands',
  async (
    {
      accountId,
      listId,
      brands,
    }: { accountId: string; listId: string; brands: BrandReadModel[] },
    { dispatch }
  ) => {
    const enablePersonalizedBrandRanking = getFlag(
      'enablePersonalizedBrandRanking',
      false
    );
    if (!enablePersonalizedBrandRanking) {
      dispatch(
        recievedBrands({
          listId,
          brands,
        })
      );
      return;
    }

    try {
      // const res = await executeQuery<
      //   GetPersonalizedBrandRankingQuery,
      //   GetPersonalizedBrandRankingQueryVariables
      // >(getPersonalizedBrandRanking, {
      //   accountId,
      //   brandIds: brands.map((brand) => brand.id!),
      // });
      // const itemIds = (res.data?.getPersonalizedBrandRanking ?? []) as string[];

      dispatch(
        recievedBrands({
          listId,
          brands,
          // brands: itemIds.map(
          //   (itemId: string) => brands.find((brand) => brand.id === itemId)!
          // ),
        })
      );
    } catch (e: any) {
      warn(e);
      dispatch(
        recievedBrands({
          listId,
          brands,
        })
      );
    }
  }
);

const MAX_OFFSET = 500;
export const pagenate = createUseCase(
  'search/brand/pagenate',
  async (
    { listId, page }: { listId: string; page: number },
    { dispatch, getState }
  ) => {
    const state = getState();
    const listState = selectBrandListState(state, listId);
    if (!listState) {
      return;
    }
    let offset = 0;
    for (let i = 1; i <= page; i++) {
      const length = listState.itemsPerPage * i;
      if (length > offset + MAX_OFFSET) {
        offset = (i - 1) * listState.itemsPerPage - 1;
      }
    }
    if (offset != listState.offset) {
      dispatch(changedOffset({ listId, offset }));
    }
    dispatch(changedPage({ listId, page }));
  }
);
